import { render } from "./VideoBlock.vue?vue&type=template&id=3193aeeb&scoped=true"
import script from "./VideoBlock.vue?vue&type=script&lang=js"
export * from "./VideoBlock.vue?vue&type=script&lang=js"

import "./VideoBlock.vue?vue&type=style&index=0&id=3193aeeb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3193aeeb"]])

export default __exports__